import React from "react";
import useAuthStore from "../services/AuthService";
import Header from "../components/layouts/Header";
import Card from "../components/ui/Card";
import { cn } from "../lib/utils";
import Wrap from "../components/Wrap";
import { Toaster } from "../components/ui/toast/toaster";
import RepositoriesPage from "../features/repositories/pages/RepositoriesPage";

const HomePage: React.FC = () => {
  const { user } = useAuthStore();

  return (
    <>
      {user && <Header user={user} />}
      <Wrap>
        <Card className={cn("w-full")}>
          <RepositoriesPage />
          <Toaster />
        </Card>
      </Wrap>
    </>
  );
};

export default HomePage;
